<template>
  <div class="unbind-api" data-automation="unbindApi">
    <ux-table
      ref="table"
      :showPage="false"
      maxHeight="100%"
      :hide-on-single-page="true"
      :data="list"
      :columns="columns"
      :emptyText="$t('HT.nodata')"
      layout="total, sizes, prev, pager, next"
    ></ux-table>

    <my-footer-btn spacing="80px" padding="10px" hideConfirm @close="close"></my-footer-btn>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns: [
        // 表头数据
        {
          label: this.$t('HT.unbindApi.name'),
          prop: 'name',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: false,
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.unbind')],
                colors: ['#0087ff'],
                event: ['unbind']
              },
              on: {
                unbind: () => {
                  const title = this.$t('HT.unbindApi.unbind');
                  this.$uxModal.show({
                    title,
                    content: '',
                    confirm: () => {
                      let postData = {
                        id: this.data.id,
                        productId: params.id
                      };
                      this.unbind(postData);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      list: []
    };
  },
  created() {
    this.getInfoList(this.data.id);
  },
  methods: {
    close() {
      this.$uxModal.hide();
    },

    /**
     * 获取流量控制绑定的应用
     * @param {Number} id 唯一标识
     */
    getInfoList(id) {
      this.$uxLoading.show();
      this.$api.apply.getInfoList(id).then((res) => {
        if (res.code == 10000) {
          this.list = res.data;
        }
      });
    },

    /**
     * 解绑
     * @param {Object} params 对象
     */
    unbind(params) {
      this.$uxLoading.show();
      this.$api.apply.unbind(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.unbindSuccess'));
          this.getInfoList(this.data.id);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.unbind-api {
  width: 600px;
}
</style>
